package com.wintermar.inspection.core.ui.component.modal

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.window.Dialog
import com.wintermar.inspection.core.ui.component.modal.util.ModalAction
import com.wintermar.inspection.core.ui.component.modal.util.ModalActionContent
import com.wintermar.inspection.core.ui.component.modal.util.ModalActionModel
import com.wintermar.inspection.core.ui.component.modal.util.ModalContainer
import com.wintermar.inspection.core.ui.component.modal.util.ModalContainerConfig
import com.wintermar.inspection.core.ui.theme.LocalAppTheme

@Composable
fun ModalDialog(
    show: Boolean = false,
    isLoading: Boolean = false,
    title: String = "",
    description: String = "",
    action: ModalActionModel = ModalAction.default(),
    gradientColors: List<Color> = emptyList(),
    onDismiss: () -> Unit,
    contentHeader: (@Composable () -> Unit)? = null,
    content: @Composable (verticalPadding: Dp) -> Unit
) {
    if (!show) {
        return
    }
    val spacing = LocalAppTheme.current.dimension.spacing

    Dialog(
        onDismissRequest = onDismiss
    ) {
        ModalContainer(
            title = title,
            description = description,
            isLoading = isLoading,
            config = ModalContainerConfig(
                isBottomSheet = false,
                withBackgroundHeader = action.withBackgroundHeader,
                gradientColors = gradientColors,
            ),
            onDismiss = onDismiss,
            contentHeader = contentHeader
        ) {
            Column(
                modifier = Modifier.padding(
                    bottom = if (action.showAction) spacing.space9
                    else spacing.space0
                )
            ) {
                content(
                    if (action.withBackgroundHeader) spacing.space4 else spacing.space0
                )
            }
            Box(
                contentAlignment = Alignment.BottomCenter
            ) {
                ModalActionContent(isBottomSheet = false, action)
            }
        }
    }
}
